import { SubscriptionInterface } from "./Entities/Subscription/SubscriptionInterface";
import Store from "../Store/Store";
import Logger from "../Logger/Logger";
import { browserHistory } from "react-router";

abstract class Entity {
  public abstract data;
  public abstract getFactory();
  public reinitialize<T>(modify: any): T {
    const copiedData = {...this.data};

    Object.keys(modify || {}).forEach(key => {
      // @todo in the future, fix it well
      // Entity.resolve method and reinitialize conflicts because we are not updating the memory of class
      // so if it gets reinitialized, it will inherit initial entities.
      // Maybe replace value here with this.find() method instead of modify[key].
      if (key && key.endsWith("Ids") === true) {
        throw new Error("This entity contains relation IDS and can not be reinitialized.");
      }

      copiedData[key] = modify[key];
      return;
    });

    return this.getFactory().reinitialize(copiedData);
  }

  public all(path: string): any {
    const pieces = path.split(".");
    const target = Store.getConfigurator().getState()[pieces[0]][pieces[1]];
    return target;
  }

  public relation(path: string, identifier: number[]): any {
    const pieces = path.split(".");
    const target = Store.getConfigurator().getState()[pieces[0]][pieces[1]];

    return target.filter(entity => {
      if (Array.isArray(identifier) === true) {
        return identifier.indexOf(entity.id) !== -1;
      }

      return entity.id === identifier;
    });
  }

  public subscriptionRelation(key: number, entityId: number): SubscriptionInterface | null {
    const subscriptions = Store.getConfigurator().getState().app.subscriptions[key];

    if (typeof subscriptions === "undefined") {
      Logger.warn(`Relationship array is not found. Please make sure [${key}] is an array in store.`);
      return null;
    }

    const filtered: SubscriptionInterface[] = subscriptions.filter(subscription => {
      return subscription.entityId === entityId;
    });

    if (!!filtered && filtered.length > 0) {
      return filtered[0];
    }

    return null;
  }

  public relations(path: string, relations: string, key: number, otherwise: any = []): any[] {
    const splitted = relations.split(".");
    const target = Store.getConfigurator().getState()[splitted[0]][splitted[1]][key];
    const entities = Store.getConfigurator().getState()[path.split(".")[0]][path.split(".")[1]];

    if (typeof target === "undefined") {
      return [];
    }

    const res = this.relation(path, target) || otherwise;

    // Order them by their index on the global array.
    return res.sort((a, b) => {
      return entities.findIndex(e => e.id === a.id) > entities.findIndex(e => e.id === b.id) ? 1 : -1;
    });
  }

  protected redirect(path: string, forceLeave: boolean = false): void {

    browserHistory.push(path);

    // React-router doesn't unmount leave preventation instantly so we need this hack.
    if (forceLeave === true) {
      setTimeout(() => {
        browserHistory.push(path);
      }, 10);
    }
  }

  public newRelation(path: string, identifier: number[]): any {
    const pieces = path.split(".");
    const target = Object.keys(Store.getConfigurator().getState()[pieces[0]]?.[pieces[1]] || {})
                      .map((id) => Store.getConfigurator().getState()[pieces[0]]?.[pieces[1]]?.[id])

    return target.filter(entity => {
      if (Array.isArray(identifier) === true) {
        return identifier.indexOf(entity.id) !== -1;
      }

      return entity.id === identifier;
    });
  }

  public newRelations(path: string, relations: string, key: number, otherwise: any = []): any[] {
    const splitted = relations.split(".");
    const target = Store.getConfigurator().getState()[splitted[0]]?.[splitted[1]]?.[key];
    const entities = Object.keys(Store.getConfigurator().getState()[path.split(".")[0]]?.[path.split(".")[1]] || {})
                        .map((id) => Store.getConfigurator().getState()[path.split(".")[0]]?.[path.split(".")[1]]?.[id])

    if (typeof target === "undefined") {
      return [];
    }

    const res = this.newRelation(path, target) || otherwise;

    // Order them by their index on the global array.
    return res.sort((a, b) => {
      return entities.findIndex(e => e.id === a.id) > entities.findIndex(e => e.id === b.id) ? 1 : -1;
    });
  }
}

export { Entity };
